import React from 'react';
import './Header.scss';

function Header() {
	return (
		<header>
			<h1 className="logo">
				<span>B</span>
				<span>e</span>
				<span>n</span>
				<span>C</span>
				<span>o</span>
			</h1>
		</header>
	);
}

export default Header;
